(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const motionToggle = $('[data-motion-toggle]');
  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;
  const storedReduceMotion = (() => {
    try {
      return window.localStorage.getItem('weeReduceMotion');
    } catch {
      return null;
    }
  })();

  const isReducedMotion = () => document.documentElement.classList.contains('wee-reduce-motion');

  const setReducedMotion = (next) => {
    const value = Boolean(next);
    document.documentElement.classList.toggle('wee-reduce-motion', value);
    if (motionToggle) motionToggle.setAttribute('aria-pressed', value ? 'true' : 'false');
    try {
      window.localStorage.setItem('weeReduceMotion', value ? '1' : '0');
    } catch {}
  };

  setReducedMotion(storedReduceMotion === null ? prefersReducedMotion : storedReduceMotion === '1');

  if (motionToggle) {
    motionToggle.addEventListener('click', () => setReducedMotion(!isReducedMotion()));
  }

  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    let lastMenuFocus = null;

    const setMenuOpen = (open) => {
      const next = Boolean(open);
      mobileMenu.classList.toggle('is-open', next);
      mobileMenu.hidden = !next;
      mobileMenu.setAttribute('aria-hidden', next ? 'false' : 'true');
      menuToggle.setAttribute('aria-expanded', next ? 'true' : 'false');

      if (next) {
        lastMenuFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        const first = mobileMenu.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (first instanceof HTMLElement) first.focus();
      } else {
        if (lastMenuFocus instanceof HTMLElement) lastMenuFocus.focus();
        lastMenuFocus = null;
      }
    };

    setMenuOpen(false);

    menuToggle.addEventListener('click', () => {
      const next = !mobileMenu.classList.contains('is-open');
      setMenuOpen(next);
    });

    document.addEventListener('click', (e) => {
      if (!mobileMenu.classList.contains('is-open')) return;
      const target = e.target instanceof Element ? e.target : null;
      if (!target) return;
      if (target.closest('[data-mobile-menu]')) return;
      if (target.closest('[data-menu-toggle]')) return;
      setMenuOpen(false);
    });

    window.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!mobileMenu.classList.contains('is-open')) return;
      setMenuOpen(false);
    });
  }

  const overlay = $('[data-cart-overlay]');
  const drawer = $('[data-cart-drawer]');
  const closeButtons = $$('[data-cart-close]');
  const openButtons = $$('[data-cart-open]');
  const itemsRoot = $('[data-cart-items]');
  const subtotalRoot = $('[data-cart-subtotal]');
  const totalRoot = $('[data-cart-total]');
  const countRoots = $$('[data-cart-count]');
  const statusRoot = $('[data-cart-status]');

  const currency = (() => {
    const active = window.Shopify?.currency?.active;
    return typeof active === 'string' && active.length ? active : 'GBP';
  })();

  const formatMoney = (cents) => {
    const value = typeof cents === 'number' ? cents / 100 : 0;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
    } catch {
      return `${value.toFixed(2)} ${currency}`;
    }
  };

  const initFreeShipping = () => {
    const banner = document.querySelector('[data-free-shipping-banner]');
    if (!(banner instanceof HTMLElement)) return null;

    const headlineAmount = banner.querySelector('[data-free-shipping-headline-amount]');

    const readRate = () => {
      const baseCurrency = String(banner.getAttribute('data-free-shipping-base-currency') || 'GBP').toUpperCase();
      const activeCurrency = String(window.Shopify?.currency?.active || banner.getAttribute('data-free-shipping-currency') || baseCurrency).toUpperCase();
      if (activeCurrency === baseCurrency) return 1;

      const direct = window.Shopify?.currency?.rate;
      if (typeof direct === 'number' && Number.isFinite(direct) && direct > 0) return direct;

      const rates = window.Shopify?.currency?.rates;
      if (rates && typeof rates === 'object') {
        const fromRates = rates[activeCurrency];
        if (typeof fromRates === 'number' && Number.isFinite(fromRates) && fromRates > 0) return fromRates;
      }

      return 1;
    };

    const baseThreshold = Math.max(
      0,
      Number(banner.getAttribute('data-free-shipping-base-threshold') || banner.getAttribute('data-free-shipping-threshold') || '10000'),
    );
    const threshold = Math.max(0, Math.round(baseThreshold * readRate()));

    if (headlineAmount instanceof HTMLElement) {
      headlineAmount.textContent = formatMoney(threshold);
    }
    return null;
  };

  const freeShipping = initFreeShipping();

  let lastCartFocus = null;
  let lastCartOpener = null;

  const getFocusable = (root) => {
    if (!(root instanceof HTMLElement)) return [];
    const selector =
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.from(root.querySelectorAll(selector)).filter((el) => el instanceof HTMLElement);
  };

  const setCartOpen = (open, opener = null) => {
    if (!overlay || !drawer) return;
    const next = Boolean(open);

    overlay.classList.toggle('is-open', next);
    overlay.hidden = !next;
    drawer.classList.toggle('is-open', next);
    drawer.setAttribute('aria-hidden', next ? 'false' : 'true');
    openButtons.forEach((btn) => btn.setAttribute('aria-expanded', next ? 'true' : 'false'));
    document.body.style.overflow = next ? 'hidden' : '';

    if (next) {
      lastCartFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      lastCartOpener = opener instanceof HTMLElement ? opener : lastCartFocus;
      const closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn instanceof HTMLElement) closeBtn.focus();
      else drawer.focus();
    } else {
      if (lastCartOpener instanceof HTMLElement) lastCartOpener.focus();
      else if (lastCartFocus instanceof HTMLElement) lastCartFocus.focus();
      lastCartFocus = null;
      lastCartOpener = null;
    }
  };

  if (drawer) {
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusables = getFocusable(drawer);
      if (focusables.length === 0) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !(drawer.contains(active))) {
          e.preventDefault();
          last.focus();
        }
        return;
      }

      if (active === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  const setCounts = (count) => {
    countRoots.forEach((el) => {
      el.textContent = String(count);
      el.hidden = count <= 0;
    });
  };

  const renderCart = (cart) => {
    if (!itemsRoot || !subtotalRoot || !totalRoot) return;

    subtotalRoot.textContent = formatMoney(cart.items_subtotal_price);
    totalRoot.textContent = formatMoney(cart.total_price);
    setCounts(cart.item_count);
    if (statusRoot instanceof HTMLElement) {
      const n = Number(cart.item_count || 0);
      statusRoot.textContent = n === 1 ? 'Bag updated. 1 item.' : `Bag updated. ${n} items.`;
    }

    itemsRoot.innerHTML = '';

    if (!cart.items || cart.items.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'wee-cart-empty';
      empty.textContent = itemsRoot.getAttribute('data-empty-text') || 'Your bag is empty.';
      itemsRoot.appendChild(empty);
      return;
    }

    cart.items.forEach((item, index) => {
      const row = document.createElement('div');
      row.className = 'wee-cart-item';

      const thumb = document.createElement('a');
      thumb.className = 'wee-cart-item__thumb';
      thumb.href = item.url || '#';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.product_title || item.title || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      }

      const body = document.createElement('div');

      const top = document.createElement('div');
      top.style.display = 'flex';
      top.style.justifyContent = 'space-between';
      top.style.gap = '12px';

      const titleWrap = document.createElement('div');
      const title = document.createElement('a');
      title.href = item.url || '#';
      title.className = 'wee-cart-item__title';
      title.textContent = item.product_title || item.title || '';
      titleWrap.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('div');
        variant.className = 'wee-muted';
        variant.style.fontSize = '12px';
        variant.textContent = item.variant_title;
        titleWrap.appendChild(variant);
      }

      const price = document.createElement('div');
      price.className = 'wee-price';
      price.textContent = formatMoney(item.final_line_price);

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'wee-cart-item__remove';
      removeBtn.setAttribute('aria-label', 'Remove item');
      removeBtn.textContent = '×';

      const priceWrap = document.createElement('div');
      priceWrap.style.display = 'flex';
      priceWrap.style.alignItems = 'center';
      priceWrap.style.gap = '8px';
      priceWrap.appendChild(price);
      priceWrap.appendChild(removeBtn);

      top.appendChild(titleWrap);
      top.appendChild(priceWrap);

      const bottom = document.createElement('div');
      bottom.className = 'wee-cart-item__controls';

      const qtyWrap = document.createElement('div');
      qtyWrap.className = 'wee-cart-qty';

      const dec = document.createElement('button');
      dec.type = 'button';
      dec.className = 'wee-cart-qty__btn';
      dec.setAttribute('aria-label', 'Decrease quantity');
      dec.textContent = '−';

      const qty = document.createElement('div');
      qty.className = 'wee-cart-qty__value';
      qty.textContent = String(item.quantity || 0);

      const inc = document.createElement('button');
      inc.type = 'button';
      inc.className = 'wee-cart-qty__btn';
      inc.setAttribute('aria-label', 'Increase quantity');
      inc.textContent = '+';

      qtyWrap.appendChild(dec);
      qtyWrap.appendChild(qty);
      qtyWrap.appendChild(inc);

      const line = index + 1;
      let updating = false;

      const setDisabled = (disabled) => {
        dec.disabled = disabled;
        inc.disabled = disabled;
        removeBtn.disabled = disabled;
        row.classList.toggle('is-updating', disabled);
      };

      const updateLine = async (nextQty) => {
        if (updating) return;
        updating = true;
        setDisabled(true);
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: Math.max(0, nextQty) }),
          });
          if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
          await refreshCart();
        } catch {
          setDisabled(false);
          updating = false;
        }
      };

      dec.addEventListener('click', () => updateLine((item.quantity || 0) - 1));
      inc.addEventListener('click', () => updateLine((item.quantity || 0) + 1));
      removeBtn.addEventListener('click', () => updateLine(0));

      bottom.appendChild(qtyWrap);

      body.appendChild(top);
      body.appendChild(bottom);

      row.appendChild(thumb);
      row.appendChild(body);
      itemsRoot.appendChild(row);
    });
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
    return res.json();
  };

  const refreshCart = async () => {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch {
      if (itemsRoot) {
        itemsRoot.innerHTML = '';
        const empty = document.createElement('div');
        empty.className = 'wee-cart-empty';
        empty.textContent = itemsRoot.getAttribute('data-error-text') || 'Unable to load your bag.';
        itemsRoot.appendChild(empty);
      }
    }
  };

  const initProductForms = () => {
    const forms = $$('[data-product-form], form[action^="/cart/add"]');
    if (forms.length === 0) return;

    forms.forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;
      const wrapper = form.closest('.wee-pdp') || document;
      const variantsScript = $('[data-variants]', wrapper);
      const variantSelect = $('[data-variant-select]', form);
      const mainImg = wrapper.querySelector('.wee-pdp__main-inner img');
      const priceEl = $('[data-product-price]', wrapper);
      const compareEl = $('[data-product-compare]', wrapper);
      const saveEl = $('[data-product-save]', wrapper);
      const saveAmountEl = $('[data-product-save-amount]', wrapper);
      const atc = $('[data-atc]', form);
      const errorEl = $('[data-product-error]', form);
      const optionRoots = $$('[data-option-index]', form);

      const atcTextAvailable =
        atc?.getAttribute('data-atc-available') ||
        atc?.textContent ||
        'Add to bag';
      const atcTextSoldOut =
        atc?.getAttribute('data-atc-soldout') ||
        'Sold out';
      const atcTextAdding =
        atc?.getAttribute('data-atc-adding') ||
        'Adding…';

      let variants = [];
      if (variantsScript?.textContent) {
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch {
          variants = [];
        }
      }

      const getSelections = () =>
        optionRoots
          .sort((a, b) => Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index')))
          .map((root) => {
            const checked = root.querySelector('input[type="radio"]:checked');
            if (checked) return checked.value;
            const select = root.querySelector('select');
            return select ? select.value : '';
          });

      const findVariant = (selections) => {
        if (!Array.isArray(variants) || variants.length === 0) return null;
        return (
          variants.find((v) => Array.isArray(v.options) && v.options.every((opt, idx) => opt === selections[idx])) ||
          null
        );
      };

      const asCents = (value) => {
        if (typeof value === 'number' && Number.isFinite(value)) return value;
        if (typeof value === 'string' && value.trim().length) {
          const parsed = Number(value);
          return Number.isFinite(parsed) ? parsed : null;
        }
        return null;
      };

      const withWidth = (rawUrl, width) => {
        if (typeof rawUrl !== 'string' || !rawUrl.trim().length) return null;
        try {
          const url = new URL(rawUrl, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch {
          return rawUrl;
        }
      };

      const getVariantImageUrl = (variant) => {
        const direct =
          (variant && typeof variant.featured_image === 'string' && variant.featured_image) ||
          variant?.featured_image?.src ||
          variant?.featured_media?.preview_image?.src ||
          variant?.featured_media?.src ||
          variant?.image;
        return typeof direct === 'string' && direct.trim().length ? direct : null;
      };

      const updatePillPrices = () => {
        const baseSelections = getSelections();

        optionRoots.forEach((root) => {
          const optionIndex = Number(root.getAttribute('data-option-index') || '0');
          if (!Number.isFinite(optionIndex)) return;

          const radios = Array.from(root.querySelectorAll('input[type="radio"]'));
          if (radios.length === 0) return;

          radios.forEach((radio) => {
            if (!(radio instanceof HTMLInputElement)) return;
            const label = radio.closest('label');
            const priceNode = label ? label.querySelector('[data-pill-price]') : null;
            if (!priceNode) return;

            const selections = baseSelections.slice();
            selections[optionIndex] = radio.value;
            const variant = findVariant(selections);
            const price = variant ? asCents(variant.price) : null;

            priceNode.textContent = price === null ? '…' : formatMoney(price);
          });
        });
      };

      const setVariant = (variant) => {
        if (!variant) return;
        if (variantSelect) variantSelect.value = String(variant.id);

        if (mainImg instanceof HTMLImageElement) {
          const imgUrl = getVariantImageUrl(variant);
          if (imgUrl) {
            const next = withWidth(imgUrl, 1600) || imgUrl;
            mainImg.src = next;
            mainImg.removeAttribute('srcset');
          }
        }

        const price = asCents(variant.price);
        const compareAt = asCents(variant.compare_at_price);

        if (priceEl && price !== null) {
          priceEl.textContent = formatMoney(price);
        }

        const hasCompare =
          compareAt !== null && price !== null && compareAt > price;

        if (compareEl && compareAt !== null) {
          compareEl.textContent = formatMoney(compareAt);
          compareEl.hidden = !hasCompare;
        }

        if (saveEl) {
          saveEl.hidden = !hasCompare;
        }

        if (saveAmountEl && hasCompare) {
          saveAmountEl.textContent = formatMoney(compareAt - price);
        }

        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? atcTextAvailable : atcTextSoldOut;
        }
      };

      const updateVariantFromOptions = () => {
        if (optionRoots.length === 0 && Array.isArray(variants) && variants.length > 0) {
          setVariant(variants[0]);
          return;
        }
        const selections = getSelections();
        optionRoots
          .sort((a, b) => Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index')))
          .forEach((root, idx) => {
            const node = root.querySelector('[data-option-selected]');
            if (!node) return;
            const val = selections[idx];
            node.textContent = val || '';
          });
        const variant = findVariant(selections);
        if (variant) setVariant(variant);
        updatePillPrices();
      };

      form.addEventListener('change', (e) => {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
        if (target.matches('input[type="radio"], select')) updateVariantFromOptions();
      });

      const qtyInput = $('[data-qty-input]', form);
      const dec = $('[data-qty-dec]', form);
      const inc = $('[data-qty-inc]', form);

      const setQty = (next) => {
        if (!qtyInput) return;
        const min = Number(qtyInput.getAttribute('min') || '1');
        const value = Number.isFinite(next) ? next : min;
        qtyInput.value = String(Math.max(min, value));
      };

      if (dec) {
        dec.addEventListener('click', () => {
          if (!qtyInput) return;
          setQty(Number(qtyInput.value || '1') - 1);
        });
      }

      if (inc) {
        inc.addEventListener('click', () => {
          if (!qtyInput) return;
          setQty(Number(qtyInput.value || '1') + 1);
        });
      }

      form.addEventListener('submit', async (e) => {
        if (!variantSelect) return;
        e.preventDefault();

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        const submitBtn = atc;
        const prevText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = atcTextAdding;
        }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });

          if (!res.ok) {
            let message = 'Unable to add to bag.';
            try {
              const data = await res.json();
              if (data?.description) message = data.description;
              if (data?.message) message = data.message;
            } catch {}
            throw new Error(message);
          }

          const trigger = openButtons[0];
          if (trigger) trigger.click();
        } catch (err) {
          const msg = err instanceof Error ? err.message : 'Unable to add to bag.';
          if (errorEl) {
            errorEl.textContent = msg;
            errorEl.hidden = false;
          }
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = prevText || atcTextAvailable;
          }
        }
      });

      updateVariantFromOptions();
    });
  };

  const initCarousels = () => {
    const carousels = $$('[data-carousel]');
    if (carousels.length === 0) return;

    carousels.forEach((root) => {
      const items = $$('[data-carousel-item]', root);
      if (items.length > 0) {
        let index = Math.max(
          0,
          items.findIndex((el) => el.classList.contains('is-active')),
        );
        const intervalMs = Math.max(1000, Number(root.getAttribute('data-interval') || '5000'));

        const setActive = (nextIndex) => {
          index = ((nextIndex % items.length) + items.length) % items.length;
          items.forEach((el, i) => el.classList.toggle('is-active', i === index));
        };

        setActive(index);
        if (!isReducedMotion()) setInterval(() => setActive(index + 1), intervalMs);
        return;
      }

      const track = $('[data-carousel-track]', root);
      const prev = $('[data-carousel-prev]', root);
      const next = $('[data-carousel-next]', root);
      if (!track) return;

      const scrollByAmount = (dir) => {
        const card = track.querySelector('a, div');
        const cardWidth = card instanceof HTMLElement ? card.getBoundingClientRect().width : 320;
        const gap = 24;
        const delta = (cardWidth + gap) * 1.15 * dir;
        track.scrollBy({ left: delta, behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', () => scrollByAmount(-1));
      if (next) next.addEventListener('click', () => scrollByAmount(1));
    });
  };

  const initHeroSpotlight = () => {
    const stages = $$('[data-hero-spotlight]');
    if (stages.length === 0) return;

    const collectionCache = new Map();
    const curatedHeroHandles = [
      'scottish-wall-art',
      'scottish-scarves',
      'scottish-stationery',
      'scottish-books',
      'scottish-blankets',
      'scottish-mugs',
      'scottish-t-shirts-hoodies',
    ];

    const shuffle = (list) => {
      const next = list.slice();
      for (let i = next.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = next[i];
        next[i] = next[j];
        next[j] = temp;
      }
      return next;
    };

    const getCollectionProducts = async (handle) => {
      if (!handle) return [];
      if (collectionCache.has(handle)) return collectionCache.get(handle);

      const request = fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`, {
        headers: { Accept: 'application/json' },
      })
        .then(async (res) => {
          if (!res.ok) return [];
          const data = await res.json();
          const products = Array.isArray(data?.products) ? data.products : [];
          return products.filter((product) => {
            if (!product || typeof product !== 'object') return false;
            if (typeof product.handle !== 'string' || !product.handle.length) return false;
            if (typeof product.featured_image === 'string' && product.featured_image.length) return true;
            if (Array.isArray(product.images) && product.images.length > 0) return true;
            return false;
          });
        })
        .catch(() => []);

      collectionCache.set(handle, request);
      return request;
    };

    const getProductKey = (product) => {
      if (!product || typeof product !== 'object') return '';
      if (typeof product.id === 'number' || typeof product.id === 'string') return String(product.id);
      if (typeof product.handle === 'string') return product.handle;
      return '';
    };

    const getProductImageUrl = (product) => {
      if (!product || typeof product !== 'object') return '';
      if (typeof product.featured_image === 'string' && product.featured_image.length) return product.featured_image;
      if (Array.isArray(product.images) && product.images.length > 0) {
        const first = product.images[0];
        if (typeof first === 'string' && first.length) return first;
        if (first && typeof first.src === 'string' && first.src.length) return first.src;
      }
      return '';
    };

    const toCents = (value) => {
      if (typeof value === 'number' && Number.isFinite(value)) return Math.round(value);
      if (typeof value !== 'string') return 0;
      const trimmed = value.trim();
      if (!trimmed) return 0;
      if (trimmed.includes('.')) return Math.round(Number.parseFloat(trimmed) * 100);
      return Math.round(Number.parseInt(trimmed, 10));
    };

    const getProductPriceLabel = (product) => {
      if (!product || typeof product !== 'object') return '';

      const directMin = toCents(product.price_min);
      const directMax = toCents(product.price_max);
      if (directMin > 0 && directMax > 0 && directMax > directMin) {
        return `${formatMoney(directMin)}–${formatMoney(directMax)}`;
      }
      if (directMin > 0) return formatMoney(directMin);

      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variantPrices = variants
        .map((variant) => toCents(variant?.price))
        .filter((price) => Number.isFinite(price) && price > 0);

      if (!variantPrices.length) return '';
      const min = Math.min(...variantPrices);
      const max = Math.max(...variantPrices);
      return min === max ? formatMoney(min) : `${formatMoney(min)}–${formatMoney(max)}`;
    };

    const applyProductToCard = (card, product) => {
      if (!(card instanceof HTMLElement) || !product || typeof product !== 'object') return false;
      const href = typeof product.handle === 'string' && product.handle.length ? `/products/${product.handle}` : '';
      const title = String(product.title || '').trim();
      const imageUrl = getProductImageUrl(product);
      const priceLabel = getProductPriceLabel(product);
      if (!href || !title || !imageUrl || !priceLabel) return false;

      card.setAttribute('href', href);

      const image = card.querySelector('img');
      if (image instanceof HTMLImageElement) {
        image.src = imageUrl;
        image.alt = title;
        image.srcset = '';
      }

      const titleEl = card.querySelector('.wee-hero__spotlight-meta-title');
      if (titleEl) titleEl.textContent = title;

      const priceEl = card.querySelector('.wee-hero__spotlight-price');
      if (priceEl) priceEl.textContent = priceLabel;

      return true;
    };

    const buildMixedHeroPool = async (sourceHandle, targetCount) => {
      if (sourceHandle && sourceHandle !== 'all') {
        const products = await getCollectionProducts(sourceHandle);
        return shuffle(products).slice(0, targetCount);
      }

      const grouped = await Promise.all(
        curatedHeroHandles.map(async (handle) => ({
          handle,
          products: await getCollectionProducts(handle),
        })),
      );

      const seen = new Set();
      const guaranteed = [];
      grouped.forEach(({ products }) => {
        if (!products.length) return;
        const pick = products[Math.floor(Math.random() * products.length)];
        const key = getProductKey(pick);
        if (!key || seen.has(key)) return;
        seen.add(key);
        guaranteed.push(pick);
      });

      const combined = shuffle(
        grouped.flatMap(({ products }) =>
          products.filter((product) => {
            const key = getProductKey(product);
            return key && !seen.has(key);
          }),
        ),
      );

      const pool = guaranteed.slice();
      combined.forEach((product) => {
        if (pool.length >= targetCount) return;
        const key = getProductKey(product);
        if (!key || seen.has(key)) return;
        seen.add(key);
        pool.push(product);
      });

      return shuffle(pool).slice(0, targetCount);
    };

    stages.forEach(async (stage) => {
      let items = $$('[data-hero-spotlight-item]', stage).filter((el) => el instanceof HTMLElement);
      const shouldRandomize = stage instanceof HTMLElement && stage.dataset.weeHeroSpotlightRandom === 'true';
      const sourceHandle = stage instanceof HTMLElement ? String(stage.dataset.weeHeroSpotlightCollection || '').trim() : '';

      if (shouldRandomize && items.length > 0) {
        const freshProducts = await buildMixedHeroPool(sourceHandle, items.length);
        if (freshProducts.length) {
          const nextItems = items.slice();
          freshProducts.forEach((product, idx) => {
            const card = nextItems[idx];
            applyProductToCard(card, product);
          });
        }
      }

      if (shouldRandomize && items.length > 3) {
        const shuffled = shuffle(items);

        shuffled.forEach((el) => stage.appendChild(el));
        items = shuffled;
      }

      items.forEach((el, idx) => {
        if (idx < 3) {
          el.removeAttribute('hidden');
          el.setAttribute('data-spotlight-slot', String(idx + 1));
        } else {
          el.removeAttribute('data-spotlight-slot');
          el.setAttribute('hidden', '');
        }
      });
    });
  };

  const initHomeTileRandomImages = () => {
    const tiles = $$('[data-home-tile]').filter((el) => el instanceof HTMLElement);
    if (tiles.length === 0) return;

    const collectionCache = new Map();

    const getCollectionProducts = async (handle) => {
      if (!handle) return [];
      if (collectionCache.has(handle)) return collectionCache.get(handle);

      const request = fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`, {
        headers: { Accept: 'application/json' },
      })
        .then(async (res) => {
          if (!res.ok) return [];
          const data = await res.json();
          const products = Array.isArray(data?.products) ? data.products : [];
          return products.filter((product) => {
            if (!product || typeof product !== 'object') return false;
            if (typeof product.featured_image === 'string' && product.featured_image.length) return true;
            if (Array.isArray(product.images) && product.images.length > 0) return true;
            return false;
          });
        })
        .catch(() => []);

      collectionCache.set(handle, request);
      return request;
    };

    const getProductImageUrl = (product) => {
      if (!product || typeof product !== 'object') return '';
      if (typeof product.featured_image === 'string' && product.featured_image.length) return product.featured_image;
      if (Array.isArray(product.images) && product.images.length > 0) {
        const first = product.images[0];
        if (typeof first === 'string' && first.length) return first;
        if (first && typeof first.src === 'string' && first.src.length) return first.src;
      }
      return '';
    };

    tiles.forEach(async (tile) => {
      const handle = String(tile.dataset.homeTileCollection || '').trim();
      if (!handle) return;

      const products = await getCollectionProducts(handle);
      if (!products.length) return;

      const pick = products[Math.floor(Math.random() * products.length)];
      const imageUrl = getProductImageUrl(pick);
      if (!imageUrl) return;

      const bg = $('[data-home-tile-bg]', tile);
      if (!(bg instanceof HTMLElement)) return;

      const alt = String(pick.title || tile.querySelector('.wee-home-tile__title')?.textContent || '').trim();
      const existingImg = bg.querySelector('img');
      const fallback = bg.querySelector('.wee-home-tile__bg-fallback');

      if (existingImg instanceof HTMLImageElement) {
        existingImg.src = imageUrl;
        existingImg.removeAttribute('srcset');
        existingImg.alt = alt;
        existingImg.loading = 'lazy';
        return;
      }

      if (fallback instanceof HTMLElement) {
        fallback.style.backgroundImage = `url("${imageUrl}")`;
        return;
      }

      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = alt;
      img.loading = 'lazy';
      img.width = 1800;
      img.height = 1800;
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      bg.appendChild(img);
    });
  };

  const initDiscountCodes = () => {
    const input = $('[data-discount-code]');
    const btn = $('[data-apply-discount]');
    const message = $('[data-discount-message]');
    if (!input || !btn) return;

    const setMessage = (text) => {
      if (!message) return;
      message.textContent = text;
      message.hidden = !text;
    };

    const apply = () => {
      const code = String(input.value || '').trim();
      if (!code) {
        setMessage('Enter a code to apply.');
        input.focus();
        return;
      }

      const redirect = encodeURIComponent('/cart');
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${redirect}`;
    };

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      apply();
    });
  };

  const initLightbox = () => {
    const roots = $$('.wee-pdp__thumbs');
    const mainRoots = $$('.wee-pdp__main-inner');
    if (roots.length === 0 && mainRoots.length === 0) return;

    const links = $$('a.wee-pdp__thumb', document).filter((el) => el instanceof HTMLAnchorElement);
    const items = links
      .map((a) => String(a.getAttribute('href') || '').trim())
      .filter((href) => href.length > 0);
    if (items.length === 0) return;

    let overlay = null;
    let img = null;
    let closeBtn = null;
    let nextBtn = null;
    let prevBtn = null;
    let activeIndex = 0;
    let lastFocus = null;
    let open = false;

    const ensureOverlay = () => {
      if (overlay) return;

      overlay = document.createElement('div');
      overlay.className = 'wee-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Image preview');
      overlay.hidden = true;

      const panel = document.createElement('div');
      panel.className = 'wee-lightbox__panel wee-glass';

      img = document.createElement('img');
      img.className = 'wee-lightbox__img';
      img.alt = '';
      img.decoding = 'async';

      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'wee-lightbox__close wee-icon-button';
      closeBtn.setAttribute('aria-label', 'Close image');
      closeBtn.setAttribute('data-lightbox-close', '');
      closeBtn.textContent = '×';

      prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'wee-lightbox__nav wee-lightbox__nav--prev wee-icon-button';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.textContent = '‹';

      nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'wee-lightbox__nav wee-lightbox__nav--next wee-icon-button';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.textContent = '›';

      panel.appendChild(img);
      panel.appendChild(closeBtn);
      panel.appendChild(prevBtn);
      panel.appendChild(nextBtn);
      overlay.appendChild(panel);
      document.body.appendChild(overlay);

      const requestClose = (e) => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        setOpen(false);
      };

      overlay.addEventListener('click', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (target && target.closest('[data-lightbox-close]')) requestClose(e);
        if (e.target === overlay) requestClose(e);
      });
      closeBtn.addEventListener('click', requestClose);
      closeBtn.addEventListener('pointerup', requestClose);
      prevBtn.addEventListener('click', () => go(-1));
      nextBtn.addEventListener('click', () => go(1));
    };

    const setIndex = (idx) => {
      ensureOverlay();
      activeIndex = ((idx % items.length) + items.length) % items.length;
      if (img) img.src = items[activeIndex];
      if (prevBtn) prevBtn.hidden = items.length <= 1;
      if (nextBtn) nextBtn.hidden = items.length <= 1;
    };

    const go = (dir) => {
      if (!open) return;
      setIndex(activeIndex + dir);
    };

    const setOpen = (next) => {
      ensureOverlay();
      if (!overlay) return;
      open = next;
      overlay.hidden = !next;
      document.body.style.overflow = next ? 'hidden' : '';

      if (next) {
        lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        if (img && !img.src) setIndex(activeIndex);
        closeBtn?.focus?.();
      } else {
        lastFocus?.focus?.();
        lastFocus = null;
      }
    };

    const handleClick = (e) => {
      const target = e.target instanceof Element ? e.target : null;
      const a = target ? target.closest('a.wee-pdp__thumb') : null;
      if (!(a instanceof HTMLAnchorElement)) return;
      const href = String(a.getAttribute('href') || '').trim();
      if (!href) return;

      const idx = items.indexOf(href);
      if (idx === -1) return;
      e.preventDefault();
      setIndex(idx);
      setOpen(true);
    };

    document.addEventListener('click', handleClick);
    mainRoots.forEach((root) => {
      root.addEventListener('click', () => {
        setIndex(0);
        setOpen(true);
      });
    });

    window.addEventListener('keydown', (e) => {
      if (!open) return;
      if (e.key === 'Escape') setOpen(false);
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  };

  const initCollectionTagFilter = () => {
    const forms = $$('form[data-collection-filter]');
    if (forms.length === 0) return;

    forms.forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;
      const baseUrlRaw = form.getAttribute('data-collection-url') || form.getAttribute('action') || '';
      const baseUrl = baseUrlRaw.replace(/\/+$/, '');
      const checkboxes = $$('[data-tag-checkbox]', form).filter((el) => el instanceof HTMLInputElement);
      if (checkboxes.length === 0) return;

      form.addEventListener('submit', () => {
        const tags = checkboxes
          .filter((el) => el.checked)
          .map((el) => String(el.value || '').trim())
          .filter(Boolean);

        const nextAction = tags.length ? `${baseUrl}/${tags.join('+')}` : baseUrl;
        form.setAttribute('action', nextAction);
      });
    });
  };

  const initCollectionFilterAutosubmit = () => {
    const forms = $$('form[data-collection-filter]');
    if (forms.length === 0) return;

    forms.forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;

      const submit = () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      };

      const sort = form.querySelector('select[name="sort_by"]');
      if (sort instanceof HTMLSelectElement) {
        sort.addEventListener('change', submit);
      }

      const checks = $$('input[type="checkbox"]', form).filter((el) => el instanceof HTMLInputElement);
      checks.forEach((el) => el.addEventListener('change', submit));

      const price = $$('input[type="number"]', form).filter((el) => el instanceof HTMLInputElement);
      price.forEach((el) => {
        el.addEventListener('change', submit);
        el.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          submit();
        });
      });
    });
  };

  const initCollectionDefaultSort = () => {
    const forms = $$('form[data-collection-filter]');
    if (forms.length === 0) return;

    forms.forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;
      const defaultSort = String(form.getAttribute('data-default-sort') || '').trim();
      if (!defaultSort) return;

      const url = new URL(window.location.href);
      if (url.searchParams.has('sort_by')) return;

      url.searchParams.set('sort_by', defaultSort);
      window.location.replace(url.toString());
    });
  };

  if (overlay) overlay.addEventListener('click', () => setCartOpen(false));
  closeButtons.forEach((btn) => btn.addEventListener('click', () => setCartOpen(false)));
  openButtons.forEach((btn) =>
    btn.addEventListener('click', async () => {
      setCartOpen(true, btn);
      await refreshCart();
    }),
  );

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!drawer || !drawer.classList.contains('is-open')) return;
    setCartOpen(false);
  });

  refreshCart().catch(() => {});
  initProductForms();
  initHeroSpotlight();
  initHomeTileRandomImages();
  initCarousels();
  initDiscountCodes();
  initLightbox();
  initCollectionDefaultSort();
  initCollectionTagFilter();
  initCollectionFilterAutosubmit();
})();
